'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _analyticsConstants = require('./analyticsConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = Immutable.Map({
    unreadMessageCount: 0
});

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _analyticsConstants.INTERCOM_SET_UNREAD_MESSAGES:
            return state.set('unreadMessageCount', action.count);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/analyticsReducer.js
// module id = 1663
// module chunks = 0